import { getAuth } from 'firebase/auth';

export function checkAuthState(setIsAuthenticated, setLoading) {
  const auth = getAuth();

  return auth.onAuthStateChanged((user) => {
    if (user) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  });
}
